// extracted by mini-css-extract-plugin
export default {"wrapper":"NewLoveRubyFuse_wrapper__NNI9q","contentMarginTop":"NewLoveRubyFuse_contentMarginTop__cD6GU","rubyMarginTop":"NewLoveRubyFuse_rubyMarginTop__QOVbz"};